import { ShopConstants } from '../_constants';

//-- add shop and shopkeeper
export function addShopAndShopkeeper(state = {}, action) {
  switch (action.type) {
    case ShopConstants.SHOP_ADDED_REQUEST:
      return {
        addShopAndShopkeeper: false
      };

    case ShopConstants.SHOP_ADDED_SUCCESS:
      //console.log("ASC ", action.user);
      return { addShopAndShopkeeper:action.successAction};

    case ShopConstants.SHOP_ADDED_FAILURE:
      return {
        addShopAndShopkeeper: false,
      };

    default:
      return state
  }
}


//-- get shop and shopkeeper list
export function getShopAndShopkeeperList(state = {}, action) {
  switch (action.type) {
    case ShopConstants.GET_SHOP_AND_SHOPKEEPR_LIST_REQUEST:        
      return {
        getShopAndShopkeeperList: false
      };

    case ShopConstants.GET_SHOP_AND_SHOPKEEPR_LIST_SUCCESS:
        console.log("action.successAction---------------------",action.successAction);
      return { getShopAndShopkeeperList:action.successAction};

    case ShopConstants.GET_SHOP_AND_SHOPKEEPR_LIST_FAILURE:
      return {
        getShopAndShopkeeperList: false,
      };

    default:
      return state
  }
} 


export function updateShopAndShopkeeperList(state = {}, action) {
  switch (action.type) {
    case ShopConstants.SHOP_UPDATE_REQUEST:        
      return { updateShopAndShopkeeper: false };

    case ShopConstants.SHOP_UPDATE_SUCCESS:        
      return { updateShopAndShopkeeper:action.successAction };

    case ShopConstants.SHOP_UPDATE_FAILURE:
      return { updateShopAndShopkeeper: false };

    default:
      return state
  }
}



//-- get single shop and shopkeeper list
export function getShopkeeper(state = {}, action) {
  switch (action.type) {
    case ShopConstants.GET_SHOPKEEPR_REQUEST:        
      return { data: false };

    case ShopConstants.GET_SHOPKEEPR_SUCCESS:        
      return { data:action.successAction };

    case ShopConstants.GET_SHOPKEEPR_FAILURE:
      return { data: false };
      
    default:
      return state
  }
}
